import React from 'react'

const TopSellerShimmer = ({index}) => {
  return (
    <>
    <div className='d-flex shine shadow' key={index}
     style={{height:'60px',width:'60px',borderRadius:'50%'}}>
    </div>
    </>
  )
}

export default TopSellerShimmer
